import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import useStyles from "./styles";

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import { CircularProgress } from '@material-ui/core';

import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { Avatar, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction, DialogTitle, Dialog, IconButton } from '@material-ui/core';

import VisibilityIcon from '@material-ui/icons/Visibility';
import { toast } from "react-toastify";
import { pathOr } from "ramda";

import {
  getPDFTemplates,
} from "../../../../../store/actions/module.actions";



export default function AcitonPopup({ actionName, module, selectedValue, setSelectedValue, actionPopupOpen, setActionPopupOpen }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // const { listViewTabData } = useSelector((state) => state.modules);

  const classes = useStyles();
  // const data = pathOr([], ['data', 'templateMeta', 'data'], listViewTabData['AOS_PDF_Templates']);

  // if (actionName === 'LBL_PRINT_AS_PDF' && module === 'AOS_Quotes' && module === 'AOS_Invoices') {

  const getListViewData = useCallback(
    () => {
      setLoading(true);
      dispatch(getPDFTemplates('AOS_PDF_Templates', module)).then(function (res) {
        setData(pathOr([], ['data', 'templateMeta', 'data'], res));
        setLoading(false);
      });
    },
    [dispatch]
  );

  useEffect(
    () => {
      getListViewData();
    },
    [getListViewData]
  );
  // }

  const handleClose = () => {
    setActionPopupOpen(false);
  };

  const handleListItemClick = (value) => {
    setSelectedValue(value);
    setLoading(true);
    // setActionPopupOpen(false);
  };
  const redirectOnPreview = (module, id) => {
    // console.log(module, id, "redirectOnPreview")
    history.push("/app/detailview/" + module + "/" + id)
  };
  // console.log(actionName, data)
  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={actionPopupOpen}>
      {/* {actionName === 'LBL_PRINT_AS_PDF' && module === 'AOS_Quotes' && module === 'AOS_Invoices' ? */}
      <>
        <DialogTitle className={classes.dialogBox} id="simple-dialog-title">Please Select a Template</DialogTitle>
        <List>

          {loading ? <ListItem button ><CircularProgress className={classes.loadingCircular} /> </ListItem> : data.map((row) => (

            <ListItem button onClick={() => handleListItemClick(row.id)} key={row.id}>
              <ListItemAvatar>
                <Avatar className={classes.avatar}>
                  <PictureAsPdfIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={row.attributes.name} />
              <ListItemSecondaryAction>

                <a target='_blank' href={"/app/detailview/AOS_PDF_Templates/" + row.id}>
                  <IconButton edge="end" aria-label="Preview" >

                    <VisibilityIcon />

                  </IconButton></a>
              </ListItemSecondaryAction>
            </ListItem>
          ))}

        </List>
      </>
      {/* : null} */}
    </Dialog>
  );
}

AcitonPopup.propTypes = {
  actionPopupOpen: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

